import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {SharedService} from '../../../shared/shared.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService} from 'angular-2-local-storage';
import {ManageCardsService} from '../manage-cards.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {FormControl, Validators} from '@angular/forms';
import * as moment from 'moment'
import {CashOnlyDialog} from '../../../dashboard/dashboard/dashboard.component';

declare var $: any;

const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
const DATE_REGEX = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;

@Component({
  selector: 'app-manage-card-on-file',
  templateUrl: './manage-payment-methods.component.html',
  styleUrls: ['./manage-payment-methods.component.css'],
})
export class ManagePaymentMethodsComponent implements OnInit {
  zipCodeFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(ZIPCODE_REGEX)]);

  cardExpirationFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(DATE_REGEX)]);

  protected readonly moment = moment;
  public card_details: Array<any>;
  public isCardErrors = false;
  public isSettingPrimaryCard = false;
  public card_detail_update: Object;
  public card_ending_digit: string;
  public expiration_date;
  public ccv;
  public card_type: string;
  public card_name: Object;
  public card_name_update: string;
  public is_savecard_loader: boolean;
  public autopay_amount: number;
  public isCashOnly: boolean;
  public minimum_balance: number;
  public primary_card: any;
  public auto_pay: boolean;
  public process_auto_pay: boolean;
  public autopayMinimum: number;
  public is_autopay_blocked: boolean;
  public billing_zip_code;
  public tempZipCode;
  public billToZip: boolean;
  public is_billingZip_error: boolean;
  public validateCard_error: string;
  public zipCode_valid: boolean;
  public update_button: string;
  public isUpdatingCard = false;
  public selected_CardID: string;
  public isEditingCard = false;
  public statusMessage = '';
  public currentCardBeingEdited = undefined;
  public newExpirationDate = undefined;
  public tempExpirationDate = undefined;
  public date = new FormControl(moment());
  public isValidExpirationDate = false;
  public isSettingPrimaryOption = false;
  public isDeletingProfile = false;
  public isDeletingLastProfile = false;
  public activeEditingProfile = undefined;
  public isPrimaryOption = false;
  public isUpdatingPrimaryMethod = false;

  public isAddingNewPaymentMethod = false;
  public paymentProfiles = []
  constructor(
    private dialog: MatDialog,
    private sharedService: SharedService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private manageCardsService: ManageCardsService,
    private changeDetectorRefs: ChangeDetectorRef
  ) {
    this.sharedService.setHeaderTitle('manage_card');

    this.is_savecard_loader = true;
    this.billToZip = true;
    this.zipCode_valid = false;
    this.minimum_balance = 0;
    this.autopay_amount = 0;
    this.auto_pay = false;
    this.update_button = 'Update';

    if (this.localStorageService.get('token') != null) {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then((res) => {
          if (res.status === 'success' && res.isTerminated === false) {
            if (!res.isEnrolled) {
              this.router.navigate(['./dashboard']);
            } else {
              const person = res.results[0]['personal'][0];

              // Used for dataLayer.push
              const dataLayerAccountInfo = res.results[0]['personal'];

              const dataLayerEvent = 'manage card on file';
              (window as any).dataLayer.push({
                'event': dataLayerEvent,
                'accountID': dataLayerAccountInfo[0].id.toString(),
                'accountNumber': dataLayerAccountInfo[0].accountNumber.toString()
              })
              res.results[0].cards.map((result) => {
                if (result.default) {
                  this.primary_card = result;
				  this.primary_card.expiration = !result.creditCardExpiryDate.month ? undefined : result.creditCardExpiryDate.month + '/' + result.creditCardExpiryDate.year;
                  this.expiration_date = result.creditCardExpiryDate;
                  this.card_ending_digit = result.accountNumber;
                  this.billToZip = result.zip !== '';
                  if (!this.billToZip) {
                    this.isEditingCard = true;
                    this.currentCardBeingEdited = this.primary_card;
                    this.newExpirationDate = moment(this.primary_card.expiration).format('MM/YY');
                    this.tempExpirationDate = moment(this.primary_card.expiration).format('MM/YY');
                    this.billing_zip_code = this.primary_card.zip;
                    this.tempZipCode = this.primary_card.zip;
                  }
                }
              });

              const this_obj = this;
              this.minimum_balance = person['balThreshold'];
              this.autopay_amount = person['autoPayAmount'];
              this.isCashOnly = res.cashOnly;
              this.is_autopay_blocked = Boolean(person['isBlockAutopay']).valueOf();
              /*if (this.is_autopay_blocked) {
                this.router.navigate(['./manage_cards']);
              }*/
              setTimeout(function () {
                this_obj.sharedService.setHeaderUserLoggedIn('manage_card', true, person);
              }, 10);
              this.updateCards('')
              this.sharedService.getConfigConst()
                .then((res2) => {
                  if (res2.status === 'success') {
                    this.autopayMinimum = res2.results[0]['autopayAmount'];
                  }
                });
            }
          } else {
            this.localStorageService.remove('token');
            this.localStorageService.set('returnUrl', 'manage_payment_methods');
            this.router.navigate(['./sign-in']);
          }
        });
    } else {
      this.localStorageService.set('returnUrl', 'manage_payment_methods');
      this.router.navigate(['./sign-in']);
    }
  }
  addNewPaymentMethod() {
    if (this.isCashOnly) {
      this.dialog.open(CashOnlyDialog);
    } else {
      this.isAddingNewPaymentMethod = true;
      this.zipCode_valid = false;
      this.isValidExpirationDate = false;
    }
  }
  refreshPaymentProfiles(profiles) {
    console.log('updating payment profiles')
    if (this.paymentProfiles !== profiles) {
      this.paymentProfiles = profiles.map((profile) => {
        const data = profile;
        if (data.type === 'VISA_DEBIT' || data.type === 'VISA_CREDIT' || data.type === 'VISA') {
          data.type = 'VISA';
        } else if (data.type === 'MC_DEBIT' || data.type === 'MC_CREDIT' || data.type === 'MC') {
          data.type = 'MASTERCARD';
		} else if (data.type === 'DISC_DEBIT' || data.type === 'DISC_CREDIT' || data.type === 'DISC') {
			data.type = 'DISCOVER';
		}
        if (profile.creditCardExpiryDate) {
          data.expiration = !profile.creditCardExpiryDate.month ? undefined : profile.creditCardExpiryDate.month + '/' + profile.creditCardExpiryDate.year;
        }
        return data;
	  }).sort((a, b) => {
		  if (a.default) {
			  return -1;
		  }
		  if (b.default) {
			  return 1;
		  }
		  return 0;

	  });
      this.card_details = this.paymentProfiles;
      this.primary_card = this.paymentProfiles.find((profile) => profile.default);
      this.isAddingNewPaymentMethod = false;
    } else {
      console.log('no update needed')
    }
  }
  updateCards(type) {
    this.statusMessage = '';
    this.manageCardsService.getPaymentProfiles(this.localStorageService.get('token')).then(res => {
      console.log(res)
      this.paymentProfiles = res.map((profile) => {
        const data = profile;
        console.log(data.type)
        if (data.type === 'VISA_DEBIT' || data.type === 'VISA_CREDIT' || data.type === 'VISA') {
          data.type = 'VISA';
        } else if (data.type === 'MC_DEBIT' || data.type === 'MC_CREDIT' || data.type === 'MC') {
          data.type = 'MASTERCARD';
        } else if (data.type === 'DISC_DEBIT' || data.type === 'DISC_CREDIT' || data.type === 'DISC') {
			data.type = 'DISCOVER';
		}
        if (profile.creditCardExpiryDate) {
          data.expiration = !profile.creditCardExpiryDate.month ? undefined : profile.creditCardExpiryDate.month + '/' + profile.creditCardExpiryDate.year;
        }
        return data;
	  }).sort((a, b) => {
		  if (a.default) {
			  return -1;
		  }
		  if (b.default) {
			  return 1;
		  }
		  return 0;

	  });
      this.card_details = this.paymentProfiles;
      this.primary_card = this.paymentProfiles.find((profile) => profile.default);
      this.is_savecard_loader = false;
      console.log(this.is_savecard_loader)
      if (type === 'delete') {
        this.statusMessage = 'Successfully deleted payment profile.'
        setTimeout(() => {
          this.statusMessage = '';
        }, 10000);
      }
    });
    this.manageCardsService.getAutoPayStatus(this.localStorageService.get('token')).then(res2 => {
		this.auto_pay = res2;
		this.localStorageService.set('autoPay', this.auto_pay);
    });
  }

  cardTypeConvert(card_types: any) {
    this.card_name = {};
    for (const card_type of card_types) {
      this.card_name[card_type.cardNo] = card_type.cardType;
    }
  }

  deleteCard(card_id: any, option: boolean) {
	  this.isSettingPrimaryOption = false;
	  const card_detail = this.card_details ? this.card_details.find(card => card && card.token === card_id) : undefined;

	  if (!card_detail) {
		  this.isDeletingProfile = false;
		  this.activeEditingProfile = undefined;
		  return;
	  }

	  if (option === undefined) {
	  	this.isDeletingProfile = true;
		  this.activeEditingProfile = card_detail;
		  return;
	  }

	  if (this.card_details.length === 1) {
		  this.isDeletingLastProfile = true;
	  }

	  this.is_savecard_loader = true;

	  const data = {
		  'token': this.localStorageService.get('token'),
		  'customerPaymentProfileId': card_id,
		  'autopay': this.auto_pay
	  }

	  this.manageCardsService.deleteCard(data).then(res => {
		  if (res.status === 'success') {
			  this.updateCards('delete');
			  this.isDeletingProfile = false;
			  this.isDeletingLastProfile = false;
			  this.is_savecard_loader = false;
		  } else {
			  this.isDeletingProfile = false;
			  this.isDeletingLastProfile = false;
			  this.is_savecard_loader = false;
			  this.statusMessage = 'Failed to delete payment profile.. please try again.'
			  setTimeout(() => {
				  this.statusMessage = '';
			  }, 10000);
		  }
	  });
  }

  setPrimaryCard(card_id: any, option: boolean, popup: boolean = true) {
	  this.isDeletingProfile = false;
    let card_detail = this.card_details ? this.card_details.find(card => card && card.token === card_id) : undefined;
    if (card_detail.default) {
      return;
    }
    if (option === undefined) {
      this.isSettingPrimaryOption = true;
      this.activeEditingProfile = card_detail;
      return;
    }
    const isPrimaryCard = this.primary_card && this.primary_card.token === card_id;
    if (isPrimaryCard) {
      card_detail = this.primary_card;
      this.isSettingPrimaryCard = false;
      return;
    }
    this.isSettingPrimaryCard = true;
    if (card_detail && card_detail.type !== 'AP' && card_detail.type !== 'GP' && !card_detail.zip) {
      const idx = this.card_details.indexOf(card_detail);
      this.triggerCardUpdate(idx, false);
      return;
    }
    this.expiration_date = card_detail.creditCardExpiryDate;
    this.card_ending_digit = card_detail.accountNumber;
    this.card_name_update = card_detail.type;

    const data = {
      'token': this.localStorageService.get('token'),
      'payAccId': card_id
    }
    this.is_billingZip_error = false;
    this.selected_CardID = card_id;
    this.billing_zip_code = null;
    this.tempZipCode = null;
    this.update_button = 'Update';
    this.isUpdatingPrimaryMethod = true;
    if (((card_detail.type !== 'AP' && card_detail.type !== 'GP' && card_detail.zip) && option === true) || option === true) {
      this.manageCardsService.setPrimaryCard(data).then(res => {
        if (res.status === 'success') {
          this.updateCards('')
          this.primary_card = card_detail
        }
        this.isUpdatingPrimaryMethod = false;
        this.isSettingPrimaryCard = false;
        this.isSettingPrimaryOption = false;
      });
    }
  }

  getLast4Digit(card_number: any) {
    const digit = card_number.split('-');
    return '*****' + digit[3];
  }
/*
  deleteCard(card_id: any, i) {
    let autopayCard = false;
    if (this.auto_pay && this.primary_card === card_id) {
      autopayCard = true;
    }
    const data = {
      'token': this.localStorageService.get('token'),
      'customerPaymentProfileId': card_id,
      'autopay': this.auto_pay
    }
    const dialogRef = this.dialog.open(ConfirmDeletePaymentMethod, {
      data: { profile: data }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.is_savecard_loader = true;
      if (result && result.status) {
        this.updateCards('delete');
      } else {
        this.is_savecard_loader = false;
        this.statusMessage = 'Failed to delete payment profile.. please try again.'
        setTimeout(() => {
          this.statusMessage = '';
        }, 10000);
      }
    });
  }*/

  ngOnInit() {

  }

  getAutoPay() {
    this.is_savecard_loader = true;
    this.manageCardsService.getAutoPayStatus(this.localStorageService.get('token')).then(res2 => {
      if (res2) {
        this.auto_pay = res2;
        this.localStorageService.set('autoPay', true);
        this.is_savecard_loader = false;
      }
    });
  }

  autoPayChange() {
  console.log('autop')
    if (this.autopay_amount < this.autopayMinimum) {
     /* const dialogRef = this.dialog.open(SuccessMessage, {
        // data: { message: 'Please add/set at least one Card as Primary for autopay.' }
        data: {
          message: 'A minimum of $' + this.autopayMinimum + ' is required for Autopay. Please update your Autopay amount settings.'
        }
      });*/
      this.getAutoPay();
    } else {
      console.log(this.primary_card)
      if (this.primary_card) {
        const auto_status = !this.auto_pay;
        const data = {
          'active': auto_status,
          'token': this.localStorageService.get('token')
        }

        this.process_auto_pay = true;
        this.is_savecard_loader = true;

        this.manageCardsService.toggleAutoPay(this.localStorageService.get('token')).then(res => {
          console.log(res)
          if (res) {
            this.process_auto_pay = false;
            this.auto_pay = res.isActive;
            this.localStorageService.set('autoPay', this.auto_pay);
            /*const dialogRef = this.dialog.open(SuccessMessage, {
              data: { message: res.message }
            });*/
          } else {
            this.process_auto_pay = false;
           /* const dialogRef = this.dialog.open(SuccessMessage, {
              // data: { message: 'Please add/set at least one Card as Primary for autopay.' }
              data: { message: res.message  }
            });*/
          }
          this.is_savecard_loader = false;
        });
      } else {
        if (this.auto_pay) {
          const auto_status = !this.auto_pay;
          const data = {
            'active': auto_status,
            'token': this.localStorageService.get('token')
          }

          this.process_auto_pay = true;
          this.is_savecard_loader = true;

          this.manageCardsService.setAutoPay(data).then(res => {
            if (res.status === 'success') {
              this.process_auto_pay = false;
              this.auto_pay = auto_status;
              this.localStorageService.set('autoPay', this.auto_pay);
              /*const dialogRef = this.dialog.open(SuccessMessage, {
                data: { message: res.message }
              });*/
            }
            this.is_savecard_loader = false;
          });
        } else {
          let message = '';
          if (this.card_details === undefined || this.card_details.length === 0){
            message = 'Please add at least one card to activate autopay.'
          }else if (this.primary_card === undefined){
            message = 'Please click on a card in the list to make it your primary card to activate autopay'
          }
        }
      }
    }
  }

  billingZipCodeValidate(update) {
    this.zipCode_valid = false;
    this.validateCard_error = null;
    if (this.billing_zip_code !== '' && this.billing_zip_code !== undefined  && this.billing_zip_code.match(ZIPCODE_REGEX)) {
      this.billToZip = false;
      this.zipCode_valid = true;
    }
	if (update) {
		this.validateCardUpdate(undefined);
	}
  }
  validateCardUpdate(event) {
	  if (!this.newExpirationDate.match(DATE_REGEX)) {
		  this.isValidExpirationDate = false;
		  return;
	  }

	  if (event && (event.keyCode === 8 || event.keyCode === 46)) {
		  return;
	  }

	  if (this.newExpirationDate && this.newExpirationDate.charAt(2) !== '/') {
		  this.newExpirationDate = this.newExpirationDate.substring(0, 2) + '/' + this.newExpirationDate.substring(2);
	  }

    const formatted = moment(this.newExpirationDate, 'MM/YY');

	  if (!formatted.isValid()) {
		  this.isValidExpirationDate = false;
		  return;
	  }

	if ('20' + this.newExpirationDate.split('/')[1] < moment().year().toString()) {
		this.cardExpirationFormControl.setErrors({'incorrect-year': true});
		this.isValidExpirationDate = false;
		return;
	}

	  this.isValidExpirationDate = true;
    this.validateCard_error = null;

	this.billingZipCodeValidate(false);
  }
  triggerCardUpdate(index: number, isPrimary: boolean = false, func: Function = () => {}) {
    this.isEditingCard = true;
    if (isPrimary) {
      this.primary_card.isEditing = true;
		const data = this.primary_card;
		if (data.type === 'VISA_DEBIT' || data.type === 'VISA_CREDIT' || data.type === 'VISA') {
			data.type = 'VISA';
		} else if (data.type === 'MC_DEBIT' || data.type === 'MC_CREDIT' || data.type === 'MC') {
			data.type = 'MASTERCARD';
		} else if (data.type === 'DISC_DEBIT' || data.type === 'DISC_CREDIT' || data.type === 'DISC') {
			data.type = 'DISCOVER';
		}
      this.currentCardBeingEdited = this.primary_card;
      this.newExpirationDate = this.primary_card.creditCardExpiryDate.month + '/' + this.primary_card.creditCardExpiryDate.year.substring(2);
      this.tempExpirationDate = this.primary_card.creditCardExpiryDate.month + '/' + this.primary_card.creditCardExpiryDate.year.substring(2);
      this.billing_zip_code = this.primary_card.zip;
      this.tempZipCode = this.primary_card.zip;
    } else if (this.card_details && this.card_details.length > 0) {
      this.currentCardBeingEdited = this.card_details[index];
		const data = this.currentCardBeingEdited;
		if (data.type === 'VISA_DEBIT' || data.type === 'VISA_CREDIT' || data.type === 'VISA') {
			this.currentCardBeingEdited.type = 'VISA';
		} else if (data.type === 'MC_DEBIT' || data.type === 'MC_CREDIT' || data.type === 'MC') {
			this.currentCardBeingEdited.type = 'MASTERCARD';
		} else if (data.type === 'DISC_DEBIT' || data.type === 'DISC_CREDIT' || data.type === 'DISC') {
			this.currentCardBeingEdited.type = 'DISCOVER';
		}
      this.currentCardBeingEdited.isEditing = true;
      this.newExpirationDate = this.currentCardBeingEdited.creditCardExpiryDate.month + '/' + this.currentCardBeingEdited.creditCardExpiryDate.year.substring(2);
      this.tempExpirationDate = this.currentCardBeingEdited.creditCardExpiryDate.month + '/' + this.currentCardBeingEdited.creditCardExpiryDate.year.substring(2);
      this.billing_zip_code = this.currentCardBeingEdited.zip;
      this.tempZipCode = this.currentCardBeingEdited.zip;
    }
  }
  anyCardErrors() {
    return this.card_details && this.card_details.some(card => card && card.type !== 'AP' && card.type !== 'GP' && (!card.zip || card.zip === false));
  }
  updateCreditCard() {
    this.zipCode_valid = false;
    this.isUpdatingCard = true;
    this.update_button = 'Updating...';
    this.card_detail_update = {
      'CardNumber': this.card_ending_digit ? this.card_ending_digit.substring(this.card_ending_digit.length - 4) : this.currentCardBeingEdited.cardNo,
      PaymentProfileId: this.currentCardBeingEdited.token,
      'ExpireMonthYear': this.newExpirationDate,
      'CCV': this.ccv,
      'CardZipCode': this.billing_zip_code,
      'token': this.localStorageService.get('token'),
      'cardName': this.card_name_update,
      'cardType': this.currentCardBeingEdited.type
    }

    this.manageCardsService.updateCard(this.card_detail_update).then(res => {
      if (res['profile-response'].status === 'fail') {
        // this.validateCard_error = res.messages.message[0].text;
        this.billToZip = true;
        this.is_billingZip_error = true;
        this.zipCode_valid = false;
        this.isUpdatingCard = false;
        this.update_button = 'Update';
        this.statusMessage = 'Failed to update card details.';
        setTimeout(() => {
          this.statusMessage = '';
        }, 10000);
      } else {
        this.isUpdatingCard = false;
		this.isEditingCard = false;
        this.update_button = 'Update';
        this.statusMessage = 'Successfully updated card details.'
        setTimeout(() => {
          this.statusMessage = '';
        }, 10000);

        this.manageCardsService.getPaymentProfiles(this.localStorageService.get('token')).then(res1 => {
          if (res1 && res1.length > 0) {
            this.cardTypeConvert(res1);
			this.refreshPaymentProfiles(res1);
            this.is_savecard_loader = false;
            if (this.isSettingPrimaryCard) {
              this.setPrimaryCard(this.currentCardBeingEdited.token, false)
            }
            this.isEditingCard = false;
            this.currentCardBeingEdited = undefined;
          }
          this.is_savecard_loader = false;
        });
        this.manageCardsService.getAutoPayStatus(this.localStorageService.get('token')).then(res2 => {
          if (res2) {
            this.auto_pay = res2;
            this.localStorageService.set('autoPay', this.auto_pay);
          }
        });
		  this.isUpdatingCard = false;
      }
    });
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'change-primary-card',
  // tslint:disable-next-line:max-line-length
  template: '<div class="dialog-main"><div class="dialog-info"><p>This card will get charged during auto payment. Are you sure you want to set this card as primary?</p></div></div><div class="footer"><button mat-button class="double-block-btn" (click)="changePrimaryCard()" style="width:50%;display: inline-block;border-bottom-left-radius: 7px;">Ok</button><button mat-button class="double-block-btn" (click)="cancel()" style="width:50%;display: inline-block;border-bottom-right-radius: 7px;">Cancel</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class ManagePaymentsChangePrimaryCard {
  constructor(public dialogRef: MatDialogRef<ManagePaymentsChangePrimaryCard>, private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any, public manageCardsService: ManageCardsService) {

  }

  changePrimaryCard() {
    this.dialogRef.close({ 'status': true });
    this.manageCardsService.setPrimaryCard(this.data.cardname).then(res => {
      if (res.status === 'success') {
        this.dialogRef.close({ 'data': this.data.cardname, 'status': true });
       /* const goodDialog = this.dialog.open(SuccessMessage, {
          data: { message: res.message }})*/
      } else {
        /*const badDialog = this.dialog.open(SuccessMessage, {
          data: { message: res.message }})*/
      }
    });
  }

  cancel() {
    this.dialogRef.close({ 'status': false });
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'confirm-delete-card',
  // tslint:disable-next-line:max-line-length
  template: '<div class="dialog-main"><div class="dialog-info"><p style="text-align:center">Are you sure you want to delete this payment method?</p><ng-template [ngIf]="data.profile.autopay"><div><p style="text-align:center">If this is your primary card, you will be removed from autopay.</p></div></ng-template></div></div><div class="footer"><button mat-button class="double-block-btn" (click)="confirmDeleteCard()" style="width:50%;display: inline-block;border-bottom-left-radius: 7px;">Ok</button><button mat-button class="double-block-btn" (click)="cancel()" style="width:50%;display: inline-block;border-bottom-right-radius: 7px;">Cancel</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class ConfirmDeletePaymentMethod {
  constructor(public dialogRef: MatDialogRef<ConfirmDeletePaymentMethod>,
              @Inject(MAT_DIALOG_DATA) public data: any, public manageCardsService: ManageCardsService, private dialog: MatDialog) {

  }

  confirmDeleteCard() {

    this.manageCardsService.deleteCard(this.data.profile).then(res => {
      if (res.status === 'success') {
        this.dialogRef.close({ 'status': true });
      } else {
        this.cancel();
      }
    });
  }

  cancel() {
    this.dialogRef.close({ 'status': false });
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/manage-cards/manage-payment-methods/manage-card-on-file.component.ts